<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <main class="common-main">
      <div class="item">

        <!-- 認証済みの時はメインの画面を表示 -->
        <div v-if="signedIn">
          <template v-if="isLoading">
            <div class="loading"></div>
          </template>
          <div v-else-if="hasUserData">
            <template v-if="isAdviser || isStaff">
            </template>
            <template v-else>
              <a :href="'/profile/' + userId">
                <div class="profile-box">
                  <span class="icon"><img :src="profileIconUrl" width="92px"></span>
                  <span class="name">{{profileDisplayName}}</span>
                  <span class="error">{{profileAlert}}<p style="font-size: small;" v-if="profileAlert">アドバイザーからの回答がよりあなたに適したものになります。</p></span>
                  <span class="survive" v-if="enableSurviveModule"><span class="label">サバイバー歴</span> {{surviveDate}}</span>
                  <template v-if="paymentActiveStatus">
                    <span class="payment">{{paymentMode}}</span>
                    <template v-if="!paymentManagementButtonHidden">
                      <form v-if="paymentMode === '有料プランご利用中'" :action="paymentCustomerPortalApiUrl" method="POST">
                        <input type="hidden" name="customerId" :value="paymentCustomerId" />
                        <button type="submit">支払いの管理</button>
                      </form>
                      <div v-else  class="item">
                        <a href="/payment"><button class="footerNavi-button button-primary">有料プラン（月額3,980円）を利用開始</button></a>
                      </div>
                    </template>
                  </template>
                </div>
              </a>

              <GuideModuleItem :createButton="true" />
            </template>
            <h2 class="common-title">お知らせ</h2>
            <template v-if="isInformationLoading">
              <div class="loading"></div>
            </template>
            <template v-else-if="hasInformationData">
              <div class="item" v-for="information in informationData" :key="information.id">
                <dl class="info">
                  <dt class="info-dt">
                    <span class="info-title">{{information.notificationType}}</span>
                    <span class="info-date">
                      【
                      <template v-if="information.notificationTargetGroup === 'all'">
                        全体向け
                      </template>
                      <template v-if="information.notificationTargetGroup === 'adviser'">
                        <template v-if="information.isForIndividuals">【個別】</template>アドバイザー向け
                      </template>
                      <template v-if="information.notificationTargetGroup === 'user'">
                        <template v-if="information.isForIndividuals">【個別】</template>ユーザー向け
                      </template>
                      】
                      {{information.notificationStartDate | date}}
                    </span>
                  </dt>
                  <dd class="info-dd">
                    {{information.notificationText}}
                    <a v-if="information.notificationUrl" :href="information.notificationUrl"><br>▶関連リンク</a>
                  </dd>
                </dl>
              </div>

              <a href="/noticeList">
                <button class="footerNavi-button button-secondary">
                  すべて確認
                </button>
              </a>
            </template>
            <template v-else>
              <ul class="list-wrap notice-list">
                <li class="list-body">
                  <div class="list-main"><p class="listbody-text">お知らせはありません</p></div>
                </li>
              </ul>
            </template>

            <br />
            <br />
            <br />

            <h2 class="common-title">相談</h2>
            <template v-if="isCounselingLoading">
              <div class="loading"></div>
            </template>
            <template v-else-if="isAdviser || isStaff">
              <ul class="list-wrap notice-list">
                <li class="list-body">
                  <div class="list-main"><p class="listbody-text">一覧から相談を確認してください</p></div>
                </li>
              </ul>
              <a href="/counselingList">
                <button class="footerNavi-button button-secondary">
                  すべて確認
                </button>
              </a>
            </template>
            <template v-else>
              <template v-if="hasCounselingData">
                <ul class="list-wrap notice-list">
                  <li class="list-body" v-for="counseling in counselingData" :key="counseling.id">
                    <a v-if="counseling.id" :href="'/counselingDetail/' + counseling.id">
                      <div class="list-status">
                        <template v-if="counseling.status === '相談中'">
                          <div class="status-label label-ing">{{counseling.status}}</div>
                        </template>
                        <template v-else>
                          <div class="status-label label-ed">{{counseling.status}}</div>
                        </template>
                        <div class="list-date">{{counseling.createAt | date}}</div>
                      </div>
                      <div class="list-main">
                        <p class="listbody-text">{{counseling.counselingText | truncate}}</p>
                      </div>
                      <div class="list-foot">
                        <div class="foot-inner">
                          <div>カテゴリ：{{counseling.counselingCategory1}} - {{counseling.counselingCategory2}}</div>
                          <!--
                          <div class="text-red">回答が来ています</div>
                          <div>2020.11.2</div>
                          -->
                        </div>
                        <div class="avator-icon">
                          <img :src="counseling.iconUrl" alt="" />
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
                <a href="/counselingList">
                  <button class="footerNavi-button button-secondary">
                    すべて確認
                  </button>
                </a>
              </template>
              <template v-else>
                <ul class="list-wrap notice-list">
                  <li class="list-body">
                    <div class="list-main"><p class="listbody-text">相談はありません</p></div>
                  </li>
                </ul>
              </template>
            </template>

            <br />
            <br />
            <br />

            <template v-if="isAdviser">
            </template>
            <template v-else-if="isStaff">
            </template>
            <template v-else>
              <a href="/counselingDetail"><button class="footerNavi-button button-primary">新規相談をする</button></a>
            </template>

            <!--
            <br />
            <div style="padding: 10px; margin-bottom: 10px; border: 1px solid #333333">
              TODO：がんの発覚から治療までの流れ画像
              <img src="https://www.mitsuihosp.or.jp/media/gan04_03.jpg" width="600" />
            </div>
            -->            
            <br />
          </div>

          <div class="text-box" v-else-if="!isInvitedUser && invitationCodeActiveStatus">
            <h2 class="common-title">ご利用コードを入力してください</h2>
            <div class="content-footerNavi">
              <dl class="item">
                <dd class="profile-input">
                  <input type="text" v-model="invitationCode" placeholder="ご利用コード" maxlength="15" />
                </dd>
                <button class="footerNavi-button button-primary" v-on:click="sendInvitationCode()" style="width:30%">
                  送信
                </button>
                <br><br>
                <dd class="profile-textSmall">ご案内している「ご利用コード」を入力してください。</dd>
                <dd class="profile-textSmall">アカウント作成時に利用する数字の「認証コード」ではありません。</dd>
              </dl>
            </div>
          </div>

          <!-- Userテーブルに新規レコードを追加。処理としてはプロフィール設定時の新規保存と同じ -->
          <div class="text-box" style="cursor: pointer;" v-else-if="!isImmediatelyAfterLogin">
            <template v-if="appClass === 'hama'">
              <h4>本サービスでは、浜松医科大学における研究へのご協力（アンケートへの回答）をお願いしています。<br><br><a href="./consent" target="_blank"><strong>「インターネットを利用したオンラインがん相談に関する研究」ご協力のお願い</strong></a> の説明をご確認いただいき、研究同意の意思を選択の上、「利用を開始する」ボタンを押してください。なお、研究への同意はプロフィール設定からいつでも変更できます。</h4><br>
              <p>※「同意しません」を選択された場合でも、「浜松オンラインがん相談 for 浜松医大」のサービスはご利用いただけます。</p>
              <br>
              <h3><a href="./consent" target="_blank"><strong>「インターネットを利用したオンラインがん相談に関する研究」ご協力のお願い</strong></a> を確認する</h3>
              <br>
              <p style="margin-left:10px; margin-right: 10px; width: 100%">
                研究に同意しますか？
                <select v-model="consentHamaMEDResearch" name="consentHamaMEDResearch" style="margin-left:10px; padding: 5px">
                  <option value="agree">同意します</option>
                  <option value="disagree">同意しません</option>
                </select>
                <br />
                <br />
                <br />
                該当するご利用条件を選択してください<br />※複数該当の場合、最も近いと思うものを選択してください
                <select v-model="usersApplicableRightsHamaMEDHospital" name="usersApplicableRightsHamaMEDHospital" style=" padding: 5px; width: 95%;">
                  <option value="浜松医大病院へご通院されている方、もしくはそのご家族・ご友人の方">浜松医大病院へご通院されている方、もしくはそのご家族・ご友人の方</option>
                  <option value="浜松市内の病院・クリニック（浜松医大病院以外）へご通院されている方、もしくはそのご家族・ご友人の方">浜松市内の病院・クリニック（浜松医大病院以外）へご通院されている方、もしくはそのご家族・ご友人の方</option>
                  <option value="浜松市内に在住、または通勤・通学をされている方">浜松市内に在住、または通勤・通学をされている方</option>
                  <option value="その他、浜松市に関係のある方（例：浜松市に転居予定の方、浜松市出身の方 等）">その他、浜松市に関係のある方（例：浜松市に転居予定の方、浜松市出身の方 等）</option>
                </select>
                <br />
                <br />
              </p>
            </template>
            <a class="link-button" v-bind:class="{'button-primary':isActiveButtonPrimary, 'button-disabled':isActiveButtonDisabled}" v-on:click="createUserData()"><template v-if="appClass === 'hama'">浜松オンラインがん相談 for 浜松医大</template><template v-else>CancerWith</template>の利用を開始する</a>
          </div>
        </div>

        <!-- 認証していない時はログイン画面を表示 -->
        <div v-else>
          <LoginItem :createButton=$route.query.createButton />
        </div>
      </div>
    </main>
    <template v-if="isAdviser || isStaff">
      <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
    </template>
    <template v-else>
      <FooterItem :contactUrl="contactUrl" />
    </template>
  </div>
</template>

<script>
import { API, Auth, Storage, graphqlOperation, Analytics, Logger } from 'aws-amplify'
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'
import GuideModuleItem from './GuideModule'

import { getUser } from "./graphql/queries"
import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { createErrorLog } from "./graphql/mutations"

// 招待コード（ご利用コード）
import { listInvitationAllowListsBySpecificUser } from './graphql/queries'
import { createInvitationAllowLists } from './graphql/mutations'


// アカウント情報取得
import { listUsersBySpecificUser } from './graphql/queries'

// お知らせ情報取得
import { listInformationsBySpecificNotificationTargetGroup } from './graphql/queries'

// 相談情報取得
import { listCounselingTopicsBySpecificCounselingUserid } from './graphql/queries'

import { createUser } from './graphql/mutations'

import moment from 'moment'

import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

const logger = new Logger('Dashboard');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'dashboard',
  components: {
    HeaderItem,
    FooterItem,
    LoginItem,
    GuideModuleItem
  },
  mixins:[Common],
  data() {
    return {
      authState: undefined,
      unsubscribeAuth: undefined,
      signedIn: false,
      id: '',
      mailaddress: '',
      userId: '',
      userType: '',
      isAdviser: false,
      isStaff: false,
      isInvitedUser: false,
      hasUserData: false,
      informationData: [],
      counselingData: [],
      hasInformationData: false,
      hasCounselingData: false,
      contactUrl: '',
      invitationCode: '',
      isLoading: true,
      isInformationLoading: true,
      isCounselingLoading: true,
      profileDisplayName: '',
      profileAlert: '',
      profileIconUrl: null,
      enableSurviveModule: false,
      surviveDate: '-',
      isActiveButtonPrimary: true,
      isActiveButtonDisabled: false,
      isPostProcessing: false,
      paymentMode: '',
      paymentCustomerId: '',
      paymentSubscriptionStatus: '',
      paymentSubscriptionStartAt: '',
      paymentSubscriptionEndAt: '',
      paymentManagementButtonHidden: false,
      paymentCustomerPortalApiUrl: '',
      paymentActiveStatus: false,
      invitationCodeActiveStatus: false,
      appClass: '',
      consentHamaMEDResearch: 'agree',
      isImmediatelyAfterLogin: false,
      usersApplicableRightsHamaMEDHospital: '',
    }
  },
  filters: {
    truncate: function (value) {
      var length = 50
      var ommision = '...'
      value = value.replace(/<br\s?\/?>/g, ' ')
      if (value.length <= length) {
        return value
      }
      return value.substring(0, length) + ommision
    },

    date: function (value) {
      var valueDate = new Date(value)
      var valueFormat = 'YYYY-MM-DD HH:mm'
      valueFormat = valueFormat.replace(/YYYY/, valueDate.getFullYear())
      
      if (valueDate.getMonth() + 1 < 10) {
        valueFormat = valueFormat.replace(/MM/, '0' + (valueDate.getMonth() + 1))
      } else {
        valueFormat = valueFormat.replace(/MM/, valueDate.getMonth() + 1)
      }
      
      if (valueDate.getDate() < 10) {
        valueFormat = valueFormat.replace(/DD/, '0' + valueDate.getDate())
      } else {
        valueFormat = valueFormat.replace(/DD/, valueDate.getDate())
      }

      if (valueDate.getHours() < 10) {
        valueFormat = valueFormat.replace(/HH/, '0' + valueDate.getHours())
      } else {
        valueFormat = valueFormat.replace(/HH/, valueDate.getHours())
      }

      if (valueDate.getMinutes() < 10) {
        valueFormat = valueFormat.replace(/mm/, '0' + valueDate.getMinutes())
      } else {
        valueFormat = valueFormat.replace(/mm/, valueDate.getMinutes())
      }
      
      return valueFormat
    }
  },

  methods: {
    download(key, num, type, i, identityId) {
      Storage.get(key, { level: 'protected', identityId: identityId })
        .then(result => {
          //console.log(result)
          
          if (!key) {
            result = null
          }
          if (type === 'icon' && result && this.counselingData[i] !== undefined) {
            var tmpData = this.counselingData[i]
            tmpData.iconUrl = result
            this.counselingData.splice(i, 1, tmpData)
            return result
          } else {
            /*
            if (num === 1) {
              this.uploadedImage1 = result
            } else if (num === 2) {
              this.uploadedImage2 = result
            } else if (num === 3) {
              this.uploadedImage3 = result
            }
            */

            // 上部プロフィールモジュール用
            if (!key) {
              result = null
            }
            this.profileIconUrl = result

            if (!this.profileIconUrl) {
              this.profileIconUrl = this.profileIconDefaultUrl
            }
            if (!this.profileIconUrl) {
              this.profileIconUrl = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/default-profile-img.png'
            }
  
          }
        })
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'Dashboard',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'Image download : Storage.get',
              errorNumber: 'Dashboard-01',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'Dashboard',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'Image download : Storage.get',
            errorNumber: 'Dashboard-01',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          //alert("画像の取得処理に失敗しました")
        })
    },

    // 招待コード（ご利用コード）認証
    sendInvitationCode: async function () {
      // 認証コード（ご利用コード）が正しいのか検証
      if (this.invitationCodes.indexOf(this.invitationCode) >= 0) {
        const invitationAllowData = {
          type: 'invitationAllowLists',
          id: this.id,
          mailAddress: this.mailaddress,
          addUser: 'system',
          createAt: new Date(),
          authenticatedInvitationCode: this.invitationCode
        }
        try {
          await API.graphql(graphqlOperation(
            createInvitationAllowLists, { input: invitationAllowData }
          ))
          alert('ご利用コードを認証しました')
          this.$destroy()
          location.reload(1)
        } catch (error) {
          //alert(JSON.stringify(userData))
          logger.error(JSON.stringify(error))
          Analytics.record({
            name: 'errorLog',
            attributes: {
              page: 'Dashboard',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'InvitationAllowList Create : createInvitationAllowLists',
              errorNumber: 'Dashboard-03',
              errorMessage: JSON.stringify(error)
            }
          });
          const errorLog = {
            type: 'errorLog',
            page: 'Dashboard',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'InvitationAllowList Create : createInvitationAllowLists',
            errorNumber: 'Dashboard-03',
            errorMessage: JSON.stringify(error),
            addUser: 'system',
            createAt: new Date()
          }
          await API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          alert('ご利用コードの認証に失敗しました')
          this.invitationCode = ''
        }
      } else {
        alert('入力されたご利用コードは無効です')
        this.invitationCode = ''
      }
    },

    // 利用開始ボタンでUserレコードを作成
    createUserData: async function () {
      if (this.appClass !== 'hama') {
        this.consentHamaMEDResearch = ''
      } else {
        if (this.usersApplicableRightsHamaMEDHospital == '') {
          alert('該当するご利用条件を選択してください')
          return
        }
      }
      if (!this.isPostProcessing) {
        this.isPostProcessing = true
        this.isActiveButtonPrimary = false
        this.isActiveButtonDisabled = true

        // デフォルトの表示名をidから生成
        var idSplited = this.id.split('-')
        this.displayName = idSplited[0] + '-****'
        if (!this.type) {
          this.type = 'user'
        }

        // デフォルト画像からランダムに初期値設定
        let random = ('0' + (Math.floor(Math.random() * (10)) + 1)).slice(-2)
        this.iconDefaultUrl = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/salmi' + random + '.png'

        const userData = {
          type: this.type,
          id: this.id,
          mailAddress: this.mailaddress,
          displayName: this.displayName,
          lastName: '',
          firstName: '',
          relationship: '',
          birthDate: '0000-01-01',
          gender: '-',
          isLiveInJapan: true,
          postalCode: '-',
          cancerType: '[]',
          cancerStage: '',
          diagnosedDate: null,
          diagnosedReason: '',
          hospitalName: '',
          curativeStatus: null,
          cancerHistory: null,
          diagnosedCancerType: '[]',
          specialty: null,
          affiliation: null,
          businessTitle: null,
          licentiate: null,
          profile: null,
          iconImageKey: null,
          iconUploadedIdentityId: null,
          iconDefaultUrl: this.iconDefaultUrl,
          isDeleted: false,
          deletedReason: null,
          deletedAt: null,
          createAt: new Date(),
          updateAt: new Date(),
          consentHamaMEDResearch: this.consentHamaMEDResearch,
          usersApplicableRightsHamaMEDHospital: this.usersApplicableRightsHamaMEDHospital
        }
        //alert(JSON.stringify(userData))

        try {
          await API.graphql(graphqlOperation(
            createUser, { input: userData }
          ))
          if (this.appClass === 'hama') {
            alert("「浜松オンラインがん相談 for 浜松医大」を利用する準備が整いました")
          } else {
            alert("CancerWithを利用する準備が整いました")
          }
          location.reload(1)

        } catch (error) {
          //alert(JSON.stringify(userData))
          logger.error(JSON.stringify(error))
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'Dashboard',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              errorType: 'User Create : createUser',
              errorNumber: 'Dashboard-02',
              errorMessage: JSON.stringify(error)
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'Dashboard',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            errorType: 'User Create : createUser',
            errorNumber: 'Dashboard-02',
            errorMessage: JSON.stringify(error),
            addUser: 'system',
            createAt: new Date()
          }
          await API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          this.isActiveButtonPrimary = true
          this.isActiveButtonDisabled = false
          this.isPostProcessing = false
          alert("エラーが発生しました\nお手数おかけしますが、お問い合わせよりご連絡お願いします")
        }

        // TODO：Adviserで新規登録をしたら、adviserAllowLists の isRegistedUser を  true に変更
      }
    },
  },

  mounted() {
    this.invitationCodes = this.getInvitationCode(location.hostname)
    this.invitationCodeActiveStatus = this.getInvitationCodeActiveStatus(location.hostname)
    this.appClass = this.getAppDivClass(location.hostname)
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // ログイン直後
        this.isImmediatelyAfterLogin = true

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email
    } catch (err) {
      this.signedIn = false
    }

    // 認証情報でUserデータを確認
    try {
      let userData = await API.graphql(
        graphqlOperation(listUsersBySpecificUser, { mailAddress: this.mailaddress, limit: 1 })
      )
      this.userId = userData.data.listUsersBySpecificUser.items[0].id
      this.userType = userData.data.listUsersBySpecificUser.items[0].type

      if (userData.data.listUsersBySpecificUser.items[0].type === 'adviser') {
        this.isAdviser = true
      } else {
        this.isAdviser = false
      }
      
      // Profileデータ
      this.profileDisplayName = userData.data.listUsersBySpecificUser.items[0].displayName
      this.profileIconDefaultUrl = userData.data.listUsersBySpecificUser.items[0].iconDefaultUrl
      this.profileIconUrl = this.download(userData.data.listUsersBySpecificUser.items[0].iconImageKey, null, null, null, userData.data.listUsersBySpecificUser.items[0].iconUploadedIdentityId)
      let profileDiagnosedDate = userData.data.listUsersBySpecificUser.items[0].diagnosedDate
      let profileCurativeStatus = userData.data.listUsersBySpecificUser.items[0].curativeStatus
      // 「がんと診断された年月日」が入力されている && 
      //    「現在の状況」が「治療中（初回）」「治療中（再発）」「治療完了」「継続治療中（ホルモン療法、免疫療法ほか）」 のとき
      if (profileDiagnosedDate && 
        (profileCurativeStatus === '治療中（初回）' || profileCurativeStatus === '治療中（再発）'
        || profileCurativeStatus === '治療完了' || profileCurativeStatus === '継続治療中（ホルモン療法、免疫療法ほか）')) {

        // profileDiagnosedDate から現在までの日数を算出（TODO：「◯年◯日」の形式で計算）
        var today = moment()
        var diagnosedDate = moment(profileDiagnosedDate, 'YYYY-MM-DD')
        this.surviveDate = today.diff(diagnosedDate, 'days') + '日'
        this.enableSurviveModule = true
      }

      // 課金モードの確認
      this.paymentActiveStatus = this.getPaymentActiveStatus(location.hostname)

      // 支払いステータス
      if (this.paymentActiveStatus) {
        this.paymentCustomerId = userData.data.listUsersBySpecificUser.items[0].paymentCustomerId
        this.paymentSubscriptionStatus = userData.data.listUsersBySpecificUser.items[0].paymentSubscriptionStatus
        this.paymentSubscriptionStartAt = userData.data.listUsersBySpecificUser.items[0].paymentSubscriptionStartAt
        this.paymentSubscriptionEndAt = userData.data.listUsersBySpecificUser.items[0].paymentSubscriptionEndAt
        this.paymentManagementButtonHidden = this.getForcePaidMode(userData.data.listUsersBySpecificUser.items[0].paymentSubscriptionId)
        this.paymentMode = this.getPaymentMode(this.paymentSubscriptionStatus, this.paymentSubscriptionStartAt, this.paymentSubscriptionEndAt)
        this.paymentCustomerPortalApiUrl = 'https://' + this.getPaymentApiDomain(location.hostname) + '/subscription/customerPortal'
      }

      // 必須項目が未入力の場合にアラート表示
      let profileAlertMessage = ''
      
      var idSplited = this.id.split('-')
      if (this.profileDisplayName === idSplited[0] + '-****') {
        profileAlertMessage += '表示名'
      }
      if (userData.data.listUsersBySpecificUser.items[0].birthDate === '0000-01-01') {
        if (profileAlertMessage.length > 0) {
          profileAlertMessage += '、生年月日'
        } else {
          profileAlertMessage += '生年月日'
        }
      }
      if (userData.data.listUsersBySpecificUser.items[0].gender === '-') {
        if (profileAlertMessage.length > 0) {
          profileAlertMessage += '、性別'
        } else {
          profileAlertMessage += '性別'
        }
      }
      if (userData.data.listUsersBySpecificUser.items[0].postalCode === '-') {
        if (profileAlertMessage.length > 0) {
          profileAlertMessage += '、郵便番号'
        } else {
          profileAlertMessage += '郵便番号'
        }
      }

      if (profileAlertMessage.length > 1) {
        this.profileAlert = profileAlertMessage + 'を入力しましょう'
      }

      if (userData.data.listUsersBySpecificUser.items[0].id) {
        this.hasUserData = true  
      }
      let env = this.getEnv(location.hostname)
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // 浜松オンラインがん相談版
      } else {
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // CancerWith版
      }
      this.isLoading = false

      // アカウント設定が無い場合はプロフィール設定へ飛ばす
      /* 必須ではなくしたので飛ばさない
      if (this.signedIn && !this.hasUserData) {
        this.$router.push({ path: 'profileSetting' })
      }
      */
    } catch (err) {
      // 運営アカウントか判定
      try {
        let staffAllowData = await API.graphql(
          graphqlOperation(listStaffAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 運営モード
          this.userId = ''
          this.userType = 'adviser'
          this.isAdviser = false
          this.isStaff = true
          this.hasUserData = true
          this.contactUrl = ''
          this.isInvitedUser = true
          this.isLoading = false
        } else {
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
          this.isInvitedUser = false
          this.isLoading = false
          // アカウント設定が無い場合はプロフィール設定へ飛ばす
          /* 必須ではなくしたので飛ばさない
          if (this.signedIn && !this.hasUserData) {
            this.$router.push({ path: 'profileSetting' })
          }
          */
        }
      } catch (err) {
        // プロフィール未設定かつ運営でもない場合、招待コードの認証をしているか確認（認証済み：プロフィール登録へ、未承認：招待コード待ち）
        // プロフィール未設定かつ運営でもない場合、プロフィール登録へ
        try {
          let invitationAllowData = await API.graphql(
            graphqlOperation(listInvitationAllowListsBySpecificUser, {
              mailAddress: this.mailaddress,
              limit: 1
            })
          )
          if (
            invitationAllowData.data.listInvitationAllowListsBySpecificUser.items[0].mailAddress ===
            this.mailaddress
          ) {
            // 認証済み
            this.userId = ''
            this.userType = ''
            this.isAdviser = false
            this.isStaff = false
            this.hasUserData = false
            this.contactUrl = ''
            this.isInvitedUser = true
            this.isLoading = false
          } else {
            this.userId = ''
            this.userType = ''
            this.isAdviser = false
            this.isStaff = false
            this.hasUserData = false
            this.contactUrl = ''
            this.isInvitedUser = false
            this.isLoading = false
          }
        } catch (err) {
          // 未認証の場合
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
          this.isInvitedUser = false
          this.isLoading = false
        }
        // アカウント設定が無い場合はプロフィール設定へ飛ばす
        /* 必須ではなくしたので飛ばさない
        if (this.signedIn && !this.hasUserData) {
          this.$router.push({ path: 'profileSetting' })
        }
        */

      }
    }

    // お知らせ情報を取得
    try {
      // user or adviser
      let informationDataTarget = await API.graphql(
        graphqlOperation(listInformationsBySpecificNotificationTargetGroup, {
          notificationTargetGroup: this.userType,
          limit: 99999
        })
      )
      informationDataTarget =
        informationDataTarget.data.listInformationsBySpecificNotificationTargetGroup.items

      // 運営用 (typeがadviserなのでuser文も追加)
      if (this.isStaff) {
        let tmpInformationDataTarget = await API.graphql(
          graphqlOperation(listInformationsBySpecificNotificationTargetGroup, {
            notificationTargetGroup: 'user',
            limit: 99999
          })
        )
        tmpInformationDataTarget =
          tmpInformationDataTarget.data.listInformationsBySpecificNotificationTargetGroup.items
        informationDataTarget = informationDataTarget.concat(tmpInformationDataTarget)
      }

      // all
      let informationDataAll = await API.graphql(
        graphqlOperation(listInformationsBySpecificNotificationTargetGroup, {
          notificationTargetGroup: 'all',
          limit: 99999
        })
      )
      informationDataAll =
        informationDataAll.data.listInformationsBySpecificNotificationTargetGroup.items

      this.informationData = informationDataTarget.concat(informationDataAll)
      
      this.informationData.sort (function(a, b) {
        if (new Date(a.notificationStartDate) > new Date(b.notificationStartDate)) {
          return -1
        } else {
          return 1
        }
      })

      var tmpInformationData = []
      var count = 0
      for (var key in this.informationData) {
        var isActive = true

        // お知らせ対象出し分け
        var notificationTargetDetail = JSON.parse(this.informationData[key].notificationTargetDetail)
        this.informationData[key].isForIndividuals = false
        if (notificationTargetDetail.indexOf('all') !== -1) {
          isActive = true
        } else if (notificationTargetDetail.indexOf(this.userId) !== -1) {
          this.informationData[key].isForIndividuals = true
          isActive = true
        } else {
          isActive = false
        }

        // 期間出し分け
        var now = new Date()
        now = now.getTime()
        var start = Date.parse(this.informationData[key].notificationStartDate)
        var end = Date.parse(this.informationData[key].notificationEndDate)
        if (start < now && now < end && isActive) {
          isActive = true
        } else {
          isActive = false
        }
          
        if (isActive && count < 3) {
          tmpInformationData.push(this.informationData[key])
          count++
        }
      }
      this.informationData = tmpInformationData


      if (this.informationData.length > 0) {
        this.hasInformationData = true
      } else {
        this.hasInformationData = false
      }
      this.isInformationLoading = false
    } catch (err) {
      this.informationData = []
      this.hasInformationData = false
      this.isInformationLoading = false
    }

    // 相談情報を取得
    if (!this.isAdviser) {
      try {
        this.counselingData = await API.graphql(
          graphqlOperation(listCounselingTopicsBySpecificCounselingUserid, {
            counselingUserid: this.userId,
            limit: 99999
          })
        )
        this.counselingData = this.counselingData.data.listCounselingTopicsBySpecificCounselingUserid.items
        
        this.counselingData.sort (function(a, b) {
          if (new Date(a.createAt) > new Date(b.createAt)) {
            return -1
          } else {
            return 1
          }
        })

        // アイコン画像取得
        //let iconUrlList = []
        for (let key in this.counselingData) {
          let targetUserid = this.counselingData[key].counselingUserid
          /*
          if (iconUrlList[targetUserid]) {
            // 既に画像取得済み
            let tmpData = this.counselingData[key]
            tmpData.iconUrl = iconUrlList[targetUserid]
            this.counselingData.splice(key, 1, tmpData)
          } else {
            try {
              let userData = await API.graphql(graphqlOperation(
                getUser, {id: targetUserid, limit: 1}
              ))
              let result = this.download(userData.data.getUser.iconImageKey, null, 'icon', key, userData.data.getUser.iconUploadedIdentityId)
              iconUrlList[targetUserid] = result
            } catch (err) {
              // 取得失敗
            }
          }*/
          let userData = await API.graphql(graphqlOperation(
            getUser, {id: targetUserid, limit: 1}
          ))
          let result = null
          if (userData.data.getUser.iconImageKey) {
            this.download(userData.data.getUser.iconImageKey, null, 'icon', key, userData.data.getUser.iconUploadedIdentityId)
          } else {
            // 登録がなければデフォルトアイコン
            result = userData.data.getUser.iconDefaultUrl
          }

          // デフォルトアイコンも無ければ初期アイコン（クローズドテスト参加者のみ該当）
          if (!result) {
            result = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/default-profile-img.png'
          }

          let tmpData = this.counselingData[key]
          tmpData.iconUrl = result
          this.counselingData.splice(key, 1, tmpData)
        }

        this.counselingData = this.counselingData.splice(0, 3)

        if (this.counselingData.length > 0) {
          this.hasCounselingData = true
        } else {
          this.hasCounselingData = false
        }
        this.isCounselingLoading = false
      } catch (err) {
        this.counselingData = []
        this.hasCounselingData = false
        this.isCounselingLoading = false
      }
    } else {
      this.isCounselingLoading = false
    }

    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'Dashboard',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: this.userType
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      if (this.userType === 'user') {
        this.$gtag.pageview({
          page_path: '/user/dashboard',
          page_title: 'User:ダッシュボード (/dashboard)'
        })
      } else if (this.userType === 'adviser') {
        this.$gtag.pageview({
          page_path: '/adviser/dashboard',
          page_title: 'Adviser:ダッシュボード (/dashboard)'
        })
      }
    }
  }
}
</script>
<style>
</style>

<style src="./assets/style.css" />
